import React from 'react'
import { MerchantLocationsLoader } from 'router/Loaders'
import { MerchantIntegrationSettingsLoader } from 'router/Loaders/MerchantIntegrationSettingsLoader'
import { ManageIntegrations } from 'components/Integrations/Manage'
import IntegrationModuleLoaders from 'router/Loaders/PartnerDataLoaders'

export const ManageIntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <MerchantIntegrationSettingsLoader isParentLoaded={isParentLoaded}>
          {(isLoaded) => (
            <IntegrationModuleLoaders isParentLoaded={isLoaded}>
              <ManageIntegrations />
            </IntegrationModuleLoaders>
          )}
        </MerchantIntegrationSettingsLoader>
      )}
    </MerchantLocationsLoader>
  )
}
